<script lang="ts" setup>
const dialog = defineModel<boolean>();

withDefaults(
  defineProps<{
    maxWidth?: string | number;
    persistent?: boolean;
    useFormBody?: boolean;
  }>(),
  {
    maxWidth: 500,
  },
);

const formValid = ref(false);

const emit = defineEmits(['update:formValid']);

watch(formValid, newVal => {
  emit('update:formValid', newVal);
});
</script>

<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
    :persistent="persistent"
  >
    <component
      :is="useFormBody ? 'v-form' : 'div'"
      v-model="formValid"
      class="m-card m-dialog"
      @submit.prevent
    >
      <div class="m-dialog__title text-h6 font-weight-semibold pt-2 pb-4">
        <slot name="title" />
      </div>

      <div class="text-body-1 py-4">
        <slot />
      </div>

      <div class="m-dialog__actions d-flex align-center justify-end">
        <slot name="actions" />
      </div>
    </component>
  </v-dialog>
</template>

<style lang="scss" scoped>
.m-dialog {
  border-radius: 10px;

  &__title {
    border-bottom: 1px solid #ededed;
  }

  &__actions {
    gap: 8px;
  }
}
</style>
